import styled from 'styled-components';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { Columns } from '@components/Columns';
import { TextPairing } from '@components/TextPairing';
import { PlaceholderCloudImage } from '@components/CloudImage';
import { themeColor, themeMediaQuery, themeSpace } from '@utils/styledTheme.util';

export const SectionContainer = styled(Box)`
  width: 100%;
  position: relative;
`;

export const TextPairingContainer = styled(TextPairing)`
  .text-pairing-title {
    margin-bottom: ${themeSpace(7)};
  }
  .text-pairing-body {
    max-width: 400px;
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-body {
      max-width: 750px;
    }
  }
  ${themeMediaQuery('tablet')} {
    .text-pairing-title {
      max-width: 750px;
    }
  }
`;

export const StyledLeftImageWrapper = styled(Flex)`
  width: 100%;
  height: 100%;
  position: relative;
  transform: translate(-30px, 100px);
  z-index: 2;
  justify-content: flex-start;
  ${themeMediaQuery('below_sm')} {
    transform: translate(0px, 0px);
    justify-content: center;
  }
  ${themeMediaQuery('xl')} {
    transform: translate(-30px, 198px);
  }
`;

export const StyledRightImageWrapper = styled(Flex)`
  width: 100%;
  height: 100%;
  position: relative;
  transform: translate(30px, 0px);
  z-index: 2;
  justify-content: flex-end;
  ${themeMediaQuery('below_sm')} {
    justify-content: center;
    transform: translate(0px, 0px);
  }
`;

export const MobileWrapper = styled.div`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
  }
`;

export const StyledDesktopPrintsImage = styled(PlaceholderCloudImage)`
  height: 800px;
  ${themeMediaQuery('xl')} {
    height: 1200px;
  }
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const StyledMobilePrintsImage = styled(PlaceholderCloudImage)<{ imagePosition?: string }>`
  width: 100%;
  ${themeMediaQuery('sm')} {
    display: none;
  }
  ${themeMediaQuery('tablet')} {
    max-height: 420px;
    width: 100%;
    object-fit: cover;
    overflow: hidden;
    object-position: ${({ imagePosition }) => imagePosition};
  }
`;

export const ColumnWrapper = styled(Columns)`
  ${themeMediaQuery('below_sm')} {
    padding-left: 0rem;
    padding-right: 0rem;
  }
`;

export const StyleMiddleColumn = styled(Flex)`
  width: 100%;
  height: 100%;
  justify-content: center;
`;

export const StyledExploreButton = styled.span`
  display: flex;
  gap: ${themeSpace(1)};
  align-items: center;
  .chevron-right-icon {
    margin-top: ${themeSpace(1)};
    color: ${themeColor('purple4')};
  }
  cursor: pointer;
`;
